































































import { Component, Vue } from "vue-property-decorator";
import TopInstance from "./TopInstance.vue";
import JobsState from "./JobsState.vue";
import { TyMarketplace } from "@/classes/TayehApi";
import { Carousel, Slide } from "vue-carousel";

@Component({
  components: {
    TopInstance,
    JobsState,
    Carousel,
    Slide,
  },
})
export default class Businesses extends Vue {
  businesses: any[] = [];
  stats: any[] = [];

  async getBusinesses() {
    const res = await TyMarketplace.getTyMarketplaceShops({
      sort: "top-chart",
      per_page: 4,
    });
    this.businesses = res.data?.shops?.map((instance) => {
      return {
        name: instance.name,
        website_link: "https://" + (instance.domain?instance.domain:instance.username + ".tayeh.ir"),
        avatar: instance.logo.url,
        image_1: instance.products[0]?.image,
        image_2: instance.products[1]?.image,
      };
    });
    this.getStats();
  }

  async getStats() {
    const res = await TyMarketplace.getTyMarketplaceStats();
    this.stats = [
      {
        title: "تعداد کسب و کارها",
        value: res.data.count_of_instances,
        icon: "landing_work.svg",
      },
      {
        title: "تعداد فروش",
        value: res.data.total_sold,
        icon: "landing_buy.svg",
      },
      {
        title: "تعداد محصولات",
        value: res.data.total_products,
        icon: "landing_bag.svg",
      },
      {
        title: "فروش کسب و کار ها",
        value: res.data.total_revenue,
        icon: "landing_discount.svg",
        span: "true",
        span_value: "تومان",
      },
    ];
  }

  startFreeClicked() {
    this.$gtag.event("GoToRegister", { method: "bussinesses_list" });
  }

  mounted() {
    this.getBusinesses();
  }
}
